











































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import '@/utils/String.ts';

import {
  NetworkingStatus,
  NetworkingStatusColor,
  NetworkingStatusDescription,
  NetworkingStatusLabel,
} from '@/model/network/Networking';

import {INetworkNetworkingService} from '@/services/network/INetworkNetworkingService';

import NetworkNetworkingStore from '@/store/network/NetworkNetworking.store';

import NetworkDevicesList from '@/components/Networking/Device/NetworkDevicesList.vue';
import NetworkStatusWidget from '@/components/Networking/NetworkStatusWidget.vue';
import NetworkDevices from '@/components/Networking/Device/NetworkDevices.vue';
import PropertyDisplayer from '@/components/Utils/PropertyDisplayer.vue';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {PropertyDisplayer, NetworkDevices, NetworkStatusWidget, NetworkDevicesList},
})
export default class NetworkNetworkingStatus extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('INetworkNetworkingService'))
  public networkingService!: INetworkNetworkingService;

  private networkingStore: NetworkNetworkingStore = getModule(NetworkNetworkingStore, this.$store);

  private hostnameEditor: boolean = false;
  private hostname: string | null = null;
  private saving: boolean = false;

  private networkingStatusColor: Map<NetworkingStatus, string> = NetworkingStatusColor;
  private networkingStatusLabel: Map<NetworkingStatus, string> = NetworkingStatusLabel;
  private networkingStatusDescription: Map<NetworkingStatus, string> = NetworkingStatusDescription;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.setLoading();
    try {
      await this.networkingStore.fetchStatus();
      await this.networkingStore.fetchHostname();
      this.hostname = this.networkingStore.Hostname;
    } catch (error) {
      Notify.Error(this.logger, `Could not get hostname`, error);
    } finally {
      this.setLoaded();
    }
  }

  private editHostname() {
    this.hostnameEditor = true;
    // this.$refs.hostnameEditor as Vue & { validate: () => boolean };
  }

  private async saveHostname() {
    if (!this.hostname || this.hostname === this.networkingStore.Hostname) {
      this.hostnameEditor = false;
      return;
    }

    this.saving = true;
    try {
      await this.networkingService.setHostname(this.hostname);
      this.networkingStore.setHostname(this.hostname);
      this.hostnameEditor = false;
    } catch (error) {
      Notify.Error(this.logger, `Could not set hostname`, error);
    } finally {
      this.saving = false;
    }
  }

  private cancel() {
    this.hostname = this.networkingStore.Hostname;
    this.hostnameEditor = false;
  }
}
